module.exports = __webpack_public_path__ + "img/declaracion_patrimonial.4c41c69a.jpg";